export default "__VITE_ASSET__BaleL4AP__"